import * as React from "react";
import { useDispatch } from "react-redux";
import { Modal, Typography, Card, Box, Grid, IconButton, Icon, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CancelIcon from "../../../icons/cancelIcon.svg";
import { getPaymentMethods } from "../../payments/sagas/residentpaymentsSlice";
import NumberFormat from "react-number-format";
import ModalContentsPayMethods from "../../payments/components/ModalContentsPayMethods";
import { getDate } from "date-fns";
import { PaymentTypeEnum } from "@inosio/payments-sdk";

const useStyles = makeStyles({
  modalContainer: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderRadius: "24px",
  },
  titleText: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    fontSize: "18px !important",
    lineHeight: "22px !important",
    color: "#000000 !important",
    textAlign: "center",
  },
  cardSytle: {
    position: "relative" as "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    pointerEvents: "auto",
    width: '98%',
    maxWidth: '472px',
    minHeight: '523px',
    borderRadius: '24px',
    outline: 'none',
  }
});

interface ModalProps {
  open: boolean;
  closeCallback: () => void;
  confirmCallback: () => void;
  appFee: number;
  payMethodUuid: string;
  setPayMethodUuid: React.Dispatch<React.SetStateAction<string>>;
  setSelectedPayHandler: (feesCents: number, lastFour: string, uuid: string) => void;
  availablePaymentMethods: PaymentTypeEnum[];
}

export default function ApplicationPaymentModal(props: ModalProps) {
  const classes = useStyles();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getPaymentMethods());
  }, []);

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        onClose={(e, reason) => reason !== 'backdropClick' && props.closeCallback()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
        disableEscapeKeyDown
      >
        <Card className={classes.cardSytle}>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
            <Typography className={classes.titleText} sx={{ mt: 1 }}>
              Accept Payment
            </Typography>
            <Box sx={{ position: 'absolute', right: 0, top: 0 }}>
              <IconButton sx={{ mr: "-6px"  }} onClick={() => props.closeCallback()}>
                <Icon>
                  <img src={CancelIcon} alt="" width={24} height={24} />
                </Icon>
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ flexGrow: 1, mt: 4, mb: 8 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                  <Typography
                    sx={{
                      color: "#14142B",
                      fontSize: "18px",
                      lineHeight: "22px",
                      fontWeight: 700,
                      fontFamily: "'Open Sans', sans-serif",
                    }}
                  >
                    Application Fee:
                  </Typography>
                  <Typography
                    sx={{
                      color: "#14142B",
                      fontSize: "18px",
                      lineHeight: "21px",
                      fontWeight: 400,
                      fontFamily: "'Work Sans', sans-serif",
                      ml: 2,
                    }}
                  >
                    <NumberFormat
                      thousandsGroupStyle="thousand"
                      value={props.appFee / 100}
                      prefix="$"
                      decimalSeparator="."
                      displayType="text"
                      type="text"
                      thousandSeparator={true}
                      allowNegative={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    color: "#14142B",
                    fontSize: "18px",
                    lineHeight: "22px",
                    fontWeight: 700,
                    fontFamily: "'Open Sans', sans-serif",
                  }}
                >
                  Which Payment Method?
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ModalContentsPayMethods 
                  irpPaymentClass="OTP"
                  setSelectedPaymentHandler={props.setSelectedPayHandler}
                  targetDate={getDate(new Date())}
                  availablePaymentMethods={props.availablePaymentMethods}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', bottom: 12, right: 19 }}>
            <Button
              sx={{ '&.Mui-disabled': {
                color: '#fff'
              } }}
              disabled={!props.payMethodUuid}
              onClick={props.confirmCallback}
              variant="contained"
              id="payment-modal-btn"
            >
              Continue
            </Button>
          </Box>
        </Card>
      </Modal>
    </div>
  );
}
